import React from 'react';
import useMediaQuery from '../../hooks/useMediaQuery';

interface WelcomeImageProps {
  imageUrl: string;
  name: string;
  position: string;
}

const WelcomeImage: React.FC<WelcomeImageProps> = ({ imageUrl, name, position }) => {
  const isDesktop = useMediaQuery('(min-width: 1024px)');

  return (
    <div 
      className="relative"
      style={{ 
        width: isDesktop ? '286px' : '100%',
        height: '448px'
      }}
    >
      <img
        src={imageUrl}
        alt={name}
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 p-4 text-white">
        <h3 className="font-bold text-lg">{name}</h3>
        <p className="text-gray-200">{position}</p>
      </div>
    </div>
  );
};

export default WelcomeImage;